<template>
        <router-link :to="{name:'influencer-card',params:{id:id}}"><feather-icon icon="InstagramIcon" size="22" /> {{ name }} </router-link>
</template>

<script>

    export default {
        props: {
            id: {
                type: Number,
                required:true
            },
            name: {
                type: String,
                required:true
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>